// CASCADE + CACTUS — Theme JS
//
// Size selection and Add to Cart are handled ONLY in templates/product.liquid.
// Do not add size/variant code here: the old hardcoded VARIANT_MAPS and
// selectSize override that lived in this file sent wrong colors and sizes
// to the cart. Removed Sept 2026.

document.addEventListener('DOMContentLoaded', function() {

  // ── DETAIL ACCORDIONS ─────────────────────────────────────────
  document.querySelectorAll('.detail-header').forEach(function(header) {
    header.addEventListener('click', function() {
      var body = this.nextElementSibling;
      var icon = this.querySelector('.accordion-icon');
      if (body) body.classList.toggle('open');
      if (icon && body) icon.textContent = body.classList.contains('open') ? '−' : '+';
    });
  });

  // ── SIZE GUIDE TOGGLE ─────────────────────────────────────────
  var sizeGuideBtn = document.querySelector('.size-guide-link');
  var sizeGuideTable = document.querySelector('.size-guide-table');
  if (sizeGuideBtn && sizeGuideTable) {
    sizeGuideBtn.addEventListener('click', function() {
      sizeGuideTable.classList.toggle('open');
    });
  }

  // ── FILTER TABS ───────────────────────────────────────────────
  document.querySelectorAll('.filter-tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      document.querySelectorAll('.filter-tab').forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // (Removed the old "Added!" button flash. It turned green on every click,
  //  even when nothing was added, e.g. when no size was chosen.)

});